export default [
  {
    path: '/baits',
    name: 'baits',
    component: () => import('@/views/pages/bait/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.baits',
      resource: 'bait',
      action: 'list',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          active: true,
        },
      ],
    },
  },
  {
    path: '/baits/add',
    name: 'add-bait',
    component: () => import('@/views/pages/bait/Add.vue'),
    meta: {
      pageTitle: 'breadcrumb.baits',
      resource: 'bait',
      action: 'create',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          to: '/baits',
          active: false,
        },
        {
          text: 'breadcrumb.add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/baits/modify/:id',
    name: 'modify-bait',
    component: () => import('@/views/pages/bait/Modify.vue'),
    meta: {
      pageTitle: 'breadcrumb.baits',
      resource: 'bait',
      action: 'edit',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          to: '/baits',
          active: false,
        },
        {
          text: 'breadcrumb.modify',
          active: true,
        },
      ],
    },
  },
]
